$('document').ready(function () {
    jQuery('.embed-responsive.embed-responsive-16by9 iframe').addClass('embed-responsive-item');

    // loads scripts from views
    // each script must have a unique name
    // use jQueryOnReady in view
    for (var i = 0; i < __scriptsArray.length; i++) {
        var funcName = "";
        if (typeof (__scriptsArray[i].name) === "undefined") {
            funcName = "__fn" + __scriptsArray[i].toString().match(/^function\s*([^\s(]+)/)[1];
        } else {
            funcName = "__fn" + __scriptsArray[i].name;
        }
        if (typeof (window[funcName]) === "undefined" || !window[funcName]) {
            __scriptsArray[i]();
            window[funcName] = true;
        }
    }

    // handle superscript character consistency
    $('body :not(script)').contents().filter(function () {
        return this.nodeType === 3 && this.parentNode.nodeName != "iframe" && this.parentNode.nodeName != "embed";
    }).replaceWith(function () {
        var result = this.nodeValue;
        var listToReplace = [{ t: "™", r: "TM", c: "" }, { t: "®", r: "®", c: "reg" },
        { t: "©", r: "©", c: "copy" }, { t: "℠", r: "SM", c: "" }];
        for (var index in listToReplace) {
            var ltr = listToReplace[index];
            var regex = new RegExp('[' + ltr.t + ']', 'g');
            if (result.match(regex)) {
                if (IsParentSUPtag(this, ltr.c)) {
                    result = result.replace(regex, ltr.r);
                } else {
                    result = result.replace(regex, '<sup class="' + ltr.c + '">' + ltr.r + '</sup>');
                }
            }
        }
        return result;
    });

    function IsParentSUPtag(elem, c) {
        return $(elem).parent("sup").addClass(c).length > 0;
    }

    // carousel resource CTAs only if more than 1
    $('.resource-list .resource-list-cta-carousel').slick({
        autoplay: true,
        speed: 300,
        autoplaySpeed: 7000,
        dots: true,
        infinite: true,
        pauseOnHover: true,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        useTransform: false
    });



    $('.global-contact-select').select2();
    $('.global-industry-select').select2();


    // External link icon addition
    var externalSvg = "<svg id=\"external-link-icon\" viewBox=\"0 0 32 32\" version=\"1.1\"> <g id=\"Symbols\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"round\" stroke-linejoin=\"round\"> <g id=\"components/graphics/icons/ui/external\" stroke=\"#007bff\" stroke-width=\"2\"> <g id=\"launch-app\" transform=\"translate(6.000000, 6.000000)\"> <line x1=\"9\" y1=\"11\" x2=\"20\" y2=\"0\" id=\"Path\"></line> <polyline id=\"Path\" points=\"12,0 20,0 20,8\"></polyline> <polyline id=\"Path\" points=\"7,0 0,0 0,20 20,20 20,13\"></polyline></g></g></g></svg>";

    $("a[href^='http']:not([href*='" + location.hostname.replace("www.", "") + "'])").each(function () {
        $(this).attr("target", "_blank");
        $(this).addClass("external-link");

        if ($(this).has("img").length && !$(this).text().trim().length) {
            return; // Do not append the icon if there's only an image
        }

        if (!$(this).parent().hasClass("horizontal-card")) {
            $(this).append(externalSvg);
        }
    });



    // Jump Nav overflow on mobile
    JumpNavOverflowHandler();
    $(window).on("resize", JumpNavOverflowHandler);
    $(".jump-nav").on("scroll", JumpNavOverflowHandler);


    // Shared Language Resource Filters 
    if ($("select.language-resource-select").length) {
        $(".language-resource-select").on("select2:select", SetResourcePDFLanguage);
        SetResourcePDFLanguage(null, location.pathname.split("/")[1]);
    }

    // show video on page load
    var queryVideoName = GetQueryByName("video");
    if (queryVideoName) {
        setTimeout(function () {
            var queryVideoName = GetQueryByName("video");
            var videoCard = $(".resource-card#" + queryVideoName);

            var videoTag = videoCard.find("a.is-video,a.is-vimeo");
            if (videoTag.length) {
                videoTag.trigger('click');
            }
        }, 500);
    }

    if (typeof $$epiforms !== 'undefined') {
        $$epiforms(document).ready(function () {
            $$epiforms(".EPiServerForms").on("formsSubmitted", function (event, param1, param2) {
                // Get form name
                let formName = event.workingFormInfo && event.workingFormInfo.Name ?
                    event.workingFormInfo.Name :
                    $(event.target).closest("form").find(".Form__Title").text().trim();

                // Push form submission event to dataLayer
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: "formSubmission",
                    form_name: formName
                });

                // Push event for GTM tracking on FBPP page (this will trigger GTM to append the pixel)
                if ($('.page-template-food-beverage-landing-page').length > 0) {
                    window.dataLayer.push({
                        event: "FBPPtriggerPixel",
                    });
                }
            });
        });
    }

    // add target blank to all PDFs regardless of where they are from
    addTargetBlankToPdfLinks();
});

//MS Clarity JS trigger - no actual difference should be expected, simple markup change only
document.querySelectorAll('#desktop .main-nav > li').forEach(function (li) {
    li.addEventListener('mouseenter', function () {
        li.classList.add('clarity-nav-open');
    });
    li.addEventListener('mouseleave', function () {
        li.classList.remove('clarity-nav-open');
    });
});

function addTargetBlankToPdfLinks() {
    // Get all anchor tags on the page
    const links = document.querySelectorAll('a');

    // Loop through each link
    links.forEach(link => {
        const href = link.getAttribute('href');

        // Check if the link exists and is a PDF (accounting for query params and fragments)
        if (href && (
            href.toLowerCase().endsWith('.pdf') ||
            href.toLowerCase().match(/\.pdf(\?|#).*$/) ||
            href.toLowerCase().includes('.pdf?') ||
            href.toLowerCase().includes('.pdf#')
        )) {
            // Add target="_blank" to open in a new tab
            link.setAttribute('target', '_blank');

            // Optionally: Add rel="noopener noreferrer" for security best practices
            link.setAttribute('rel', 'noopener noreferrer');
        }
    });
}

function SetResourcePDFLanguage(e, language) {
    if (e !== null) {
        var langToUpdate = e.currentTarget.value;
    } else {
        langToUpdate = language;
    }

    var resourceList = $("select.language-resource-select").toArray();
    for (var i in resourceList) {
        var langForList = langToUpdate;
        var $thisList = $(resourceList[i]);
        if (!$thisList.find("option[value=" + langForList + "]").length) {
            langForList = location.pathname.split("/")[1];
            if (!$thisList.find("option[value=" + langForList + "]").length) {
                langForList = "en";
            }
        }
        $thisList.val(langForList);
        $thisList.trigger("change");

        $thisList.siblings("[class*='group-lang-']").hide();
        $thisList.siblings(".group-lang-" + langForList).show();
    }
}

function JumpNavOverflowHandler() {
    var $innerJumpNav = $(".inner-jump-nav-container");
    var $jumpNavContainer = $(".jump-nav-container");
    var $jumpNav = $(".jump-nav");

    var innerJumpNavWidth = $innerJumpNav.width();
    var jumpNavContainerWidth = $jumpNavContainer.width();

    if (innerJumpNavWidth > jumpNavContainerWidth) {
        var scrollLeft = $jumpNav.scrollLeft();
        var scrollWidth = $jumpNav[0].scrollWidth;

        //overflow required
        if (scrollLeft > 0) {
            $jumpNavContainer.addClass("overflow-before");
        } else {
            $jumpNavContainer.removeClass("overflow-before");
        }

        if ((scrollLeft + $jumpNav.width()) < scrollWidth) {
            $jumpNavContainer.addClass("overflow-after");
        } else {
            $jumpNavContainer.removeClass("overflow-after");
        }
    } else {
        //remove overflow classes
        $jumpNavContainer.removeClass("overflow-before").removeClass("overflow-after");
    }
}

function GetQueryInfo(hrefInfo) {
    if (!hrefInfo) {
        hrefInfo = window.location.href;
    }
    hrefInfo = hrefInfo.match(/\?[^#]*/g);

    var queries = "";
    if (hrefInfo && hrefInfo.length) {
        queries = hrefInfo[0].substr(1).split('&');
    }

    if (queries == "") return {};
    var queriesJson = {};

    for (var i = 0; i < queries.length; ++i) {
        var query = queries[i].split('=', 2);
        if (query.length == 1)
            queriesJson[query[0]] = [];
        else {
            var queryValue = decodeURIComponent(query[1].replace(/\+/g, " "));
            if (!queriesJson[query[0]]) {
                queriesJson[query[0]] = [];
            }
            queriesJson[query[0]].push(queryValue);
        }
    }

    return queriesJson;
}

// get query string parameter by name
function GetQueryByName(queryParamName) {
    queryParamName = queryParamName.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    var regex = new RegExp("[\\?&]" + queryParamName + "=([^&#]*)"), results = regex.exec(window.location.search);
    return results == null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
}



manualOffset = 0; //update this to a fixed amount of offset to avoid fixed navigation
function ScrollToOffset(offset, ignoreManual, callback) {
    if (!callback) {
        $('html, body').animate({
            scrollTop: offset + (ignoreManual ? 0 : manualOffset)
        }, 1000);
    } else {
        $('html, body').animate({
            scrollTop: offset + (ignoreManual ? 0 : manualOffset)
        }, 1000, callback);
    }
    return false;
}

$('a[href^="#"]').on('click', function (e) {
    var destination = $(this).attr("href");
    var dp = $(this).attr("data-parent") || "";
    if (destination != "#" && dp.indexOf("#accordion") !== 0) {
        ScrollToOffset($(destination).offset().top - $('header').height());
        e.preventDefault();
    }
});



$(".world-map .pill").css("width", $(".world-map .link").css("width"));
$(window).on("resize", function () {
    $(".world-map .pill").css("width", $(".world-map .link").css("width"));
});

// normalizes the height across instances of the selector based upon bootstrap columns
// ONLY works to normalize divs that share a common bootstrap column width
// examples~ col-6 : two column, col-4 : three column, col-3 : four columns
var currentHeight_screenSize;
var args_rnh = {};

function responsiveScreenSizeTest() {
    if (jQuery("#screen-test-xs:visible").length) {
        return 0;
    } else if (jQuery("#screen-test-sm:visible").length) {
        return 1;
    } else if (jQuery("#screen-test-md:visible").length) {
        return 2;
    } else if (jQuery("#screen-test-lg:visible").length) {
        return 3;
    } else {
        return 4;
    }
}
function responsiveNormalizeHeight(selector, forcePadding, condition, childSelector, init = false) {
    var screenSize = responsiveScreenSizeTest();
    if (currentHeight_screenSize != screenSize || init) {
        currentHeight_screenSize = screenSize;
        console.log("processing responsiveNormalizeHeight: " + selector + " - " + currentHeight_screenSize);
        _responsiveNormalizeHeight(selector, forcePadding, condition, childSelector);
    }
}

function delayedResponsiveNormalizeHeight(selector, forcePadding, condition, childSelector) {
    for (var i in args_rnh) {
        var a = args_rnh[i];
        _responsiveNormalizeHeight(a.selector, a.forcePadding, a.condition, a.childSelector);
    }
    args_rnh = {};
}

function _responsiveNormalizeHeight(selector, forcePadding, condition, childSelector) {
    condition = condition == undefined ? true : condition;
    childSelector = childSelector == undefined ? "" : childSelector;

    if (condition) {
        //small to large size array that maps to bootstrap columns
        var orderedSizeList = ["col", "col-sm", "col-md", "col-lg", "col-xl"];

        //looks for the current window size and saves the index relative to the orderedSizeList
        var size = currentHeight_screenSize;
        var masterSet = jQuery(selector).filter(":visible");

        //testing based upon the closest parent class that contains a col tag
        var controllingElem = jQuery(selector).closest("[class*=col]");
        //normalize
        //a.splice(1,1);
        for (var i = 0; i < controllingElem.length; i++) {
            var thisElem = jQuery(controllingElem[i]);
            if (thisElem.length) {
                var parent = thisElem.parent();
                var classes = thisElem.attr("class");

                //clean up classes before using it
                classes = classes.replace("page-hide", "").replace("product", "").replace("innovation", "").trim();

                //clearing the elements that will be normalized with 'thisElem' - optimizes out any attempts at normalizing them
                for (var j = 0; j < controllingElem.length; j++) {
                    if (jQuery(controllingElem[j]).parent()[0] == parent[0]) {
                        controllingElem[j] = null;
                    }
                }

                //at this point, we have the classes with a shared parent, so we know which ones to normalize
                //start checking at the current size for a normalizeable class col-xx-6, col-xx-4, col-xx-3
                var found = false;
                for (var j = size; j > -1; j--) {
                    var sizeToCheck = orderedSizeList[j];
                    if (thisElem.attr("class").indexOf(sizeToCheck) != -1) {
                        var children = parent.children("[class*='" + classes + "']");
                        var colToCheck = "." + sizeToCheck;
                        var column1Elems = children.filter(colToCheck + "-12"); //1 column
                        var column2Elems = children.filter(colToCheck + "-6");  //2 columns
                        var column3Elems = children.filter(colToCheck + "-4");  //3 columns
                        var column4Elems = children.filter(colToCheck + "-3");  //4 columns
                        //var remainingElems = children.not(column1Elems).not(column2Elems).not(column3Elems).not(column4Elems);
                        var numColumns = null;
                        var filterSet = null;
                        if (column1Elems.length) {
                            //one column
                            numColumns = 1;
                            filterSet = column1Elems.filter(masterSet.parent());
                        } else if (column2Elems.length) {
                            //two columns
                            numColumns = 2;
                            filterSet = column2Elems.filter(masterSet.parent());
                        } else if (column3Elems.length) {
                            //three
                            numColumns = 3;
                            filterSet = column3Elems.filter(masterSet.parent());
                        } else if (column4Elems.length) {
                            //four columns
                            numColumns = 4;
                            filterSet = column4Elems.filter(masterSet.parent());
                        }
                        //else if (remainingElems.length) {
                        //    //four columns
                        //    numColumns = 1;
                        //    filterSet = remainingElems.find(selector).filter(":visible");
                        //}

                        //if we found a filtered set, normalize them
                        if (numColumns && filterSet) {
                            for (var k = 0; k < filterSet.length; k += numColumns) {
                                var kTo = k + numColumns < filterSet.length ? k + numColumns : filterSet.length;
                                var normalizeThese = filterSet.slice(k, kTo);
                                _normalizeHeight(normalizeThese, forcePadding, true, childSelector);
                            }
                            found = true;
                        }
                    }
                    //get out because we found the biggest available size
                    if (found)
                        break;
                }
            }
        }
    }
}

var currentHeight_nh;
var currentWidth_nh;
var args_nh = {};
function normalizeHeight(selector, forcePadding, condition, childSelector, init = false) {
    var screenSize = responsiveScreenSizeTest();
    if (currentHeight_screenSize != screenSize || init) {
        currentHeight_screenSize = screenSize;
        _normalizeHeight(selector, forcePadding, condition, childSelector);
    }
}

function delayedNormalizeHeight(selector, forcePadding, condition, childSelector) {
    for (var i in args_nh) {
        var a = args_nh[i];
        _normalizeHeight(a.selector, a.forcePadding, a.condition, a.childSelector);
    }
    args_nh = {};
}

// normalizes the height across all instances of the selector
function _normalizeHeight(selector, forcedPadding, condition, childSelector) {
    condition = condition == undefined ? true : condition;
    childSelector = childSelector == undefined ? "" : childSelector;

    var mergedSelector = $(selector);
    if (childSelector.length) {
        var mergedSelector = mergedSelector.find(childSelector);
    }
    //leaning on a class that is only visible at mobile
    if (condition) {
        var maxHeight = 0;
        var cssHeight = "";
        jQuery(mergedSelector).css({ "height": '' });

        jQuery(mergedSelector).each(function () {
            var thisHeight = jQuery(this).height();
            if (thisHeight > maxHeight) {
                maxHeight = thisHeight;
                cssHeight = jQuery(this).css("height");
            }
        })
        if (forcedPadding)
            cssHeight = (maxHeight + forcedPadding) + "px";
        jQuery(mergedSelector).css({ "height": cssHeight });
    }
}
